import {
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react'
import { SlideImages } from '../SlideImages'
import { AiFillPlusCircle } from 'react-icons/ai'
export function ModalSlideImages({ images }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  function handleOpenModal() {
    if (images.length === 0) return
    onOpen()
  }

  return (
    <>
      <Flex
        gap="3px"
        alignItems="center"
        opacity={images?.length > 0 ? 1 : 0.5}
        onClick={handleOpenModal}
      >
        <Icon as={AiFillPlusCircle} w="20px" h="20px" color="#378BBF" />
        <Text textDecoration="underline">ver imagens cadastradas</Text>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent height="700px">
          <ModalHeader>Imagens</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" w="100%" gap={4}>
            <Flex w="100%">
              <SlideImages images={images} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
